import {useEffect, useState} from "react";
import '../../../static/css/home/news.css';
import {Link} from "react-router-dom";
import {PostJSON, ServerImage} from "../../../components/api/webservice";
import {ThinArrowLeft} from "../../../components/icons/material-icons";
import {HideProgressLoading} from "../../../components/template/architecture";
import {Apis} from "../../../components/api/url";

interface newsInterface {
    nd: string,
    title: string,
    body: string,
    img: string,
    category: string,
}

export const HomeNewsScreen = () => {
    const [list, setList] = useState<newsInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/home/news/list',
            {},
            false,
            (d: {
                result: string,
                reason: string,
                list: newsInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            () => {
            },
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "اطلاعیه ها | مدرسه هوشمند نهال";
        fetchList();
    }, []);
    return (
        <>
            <div data-aos="fade-up" data-aos-duration={1000}>
                <div className="home-news-hero">
                    <div className="container-big">
                        <h1>اطلاعیه های نهال</h1>
                        <p>اخبار و اطلاع رسانی های رسمی مجموعه آموزشی نهال.</p>
                    </div>
                </div>
                {
                    loaded ?
                        <section className="home-news-list">
                            <div className="container-big">
                                {
                                    list.length < 1 ?
                                        <div className="staff--not-found">
                                            <em style={{backgroundImage: 'url(/svg/news.svg)'}}/>
                                            <b>اطلاعیه‌ای یافت نشد</b>
                                            <p>در حال حاضر، اطلاعیه‌ای برای نمایش موجود نیست.</p>
                                        </div> : null
                                }
                                <div className="row">
                                    {
                                        list.map((s, i) =>
                                            <div className="col-lg-4" key={"J28SncuShSHH__S" + i}>
                                            <Link to={`/news/view/${s.nd}`}
                                                      className="news-item">
                                                    <i style={{backgroundImage: `url(${ServerImage(s.img, 400)})`}}/>
                                                    <div>
                                                        <em>{s.category}</em>
                                                        <b>{s.title}</b>
                                                        <p className="max-lines-2">{s.body}</p>
                                                        <div>
                                                            <button>
                                                                <span>مشاهده</span>
                                                                <ThinArrowLeft/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </section> :
                        null
                }
            </div>
        </>
    );
};